import { useAuth } from "../../context/AuthContext";
import { useSiteBanner } from "../../hooks/useSiteBanner";

// New Build 3 (Sep 18 2026): replaces the full-width gold banner (which pushed every logged-in
// user's page content down) with a small, admin-only status pill that floats over the page and
// never affects layout.
export function MaintenanceStatusPill() {
  const { user } = useAuth();
  const banner = useSiteBanner();

  if (user?.role !== "admin") return null;

  return (
    <div
      data-testid="maintenance-status-pill"
      title={banner.enabled ? `Maintenance banner is ON: "${banner.message}"` : "Maintenance banner is currently off"}
      className={`fixed bottom-4 right-4 z-[250] flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[11px] font-medium border shadow-lg ${
        banner.enabled
          ? "bg-igc-danger/10 border-igc-danger/40 text-igc-danger"
          : "bg-igc-success/10 border-igc-success/40 text-igc-success"
      }`}
    >
      <span className={`w-2 h-2 rounded-full ${banner.enabled ? "bg-igc-danger" : "bg-igc-success"}`} />
      Maintenance {banner.enabled ? "ON" : "OFF"}
    </div>
  );
}
